<template lang="pug">
#vendor-info
  v-banner.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ $t('Menu.__Purchase') }} : {{ editType == 1 ? $t('Vendors.__AddVendor') : $t('Vendors.__EditVendor') }}
    template(v-slot:actions)
      v-btn.ml-6(rounded, dark, color="#b4b9be", @click="$router.go(-1)") {{ $t('ActionOption.__Cancel') }}
      v-btn.ml-6(rounded, color="primary", @click="saveEdit") {{ $t('ActionOption.__Save') }}
  v-container.slim-container
    Alert
    v-form(v-model="formValid", ref="vendorform")
      .vendor-info
        .field-label 
          span {{ $t('ContactInfo.__VendorName') }}
          span.required *
        v-text-field(v-model="vendor.name", solo, dense, outlined, required, :rules="[rules.required]")
        .field-label 
          span Email
          //- span.required *
        v-text-field(v-model="vendor.email", solo, dense, outlined, required, :rules="[rules.email]")
        //- .field-label 
        //-     span 貨幣別
        //-     span.required *
        //- CurrencySelector(v-model="vendor.currencyCode" :rules="[rules.required]" )
        .field-label 
          span {{ $t('ContactInfo.__Country') }}
        CountrySeletor(v-model="vendor.countryCode")
        .field-label 
          span {{ $t('ContactInfo.__ZIPCode') }}
        v-text-field(v-model="vendor.postalCode", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__VendorAddress') }}
        v-text-field(v-model="vendor.address", solo, dense, outlined)
        v-text-field(v-model="vendor.address2", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__AccountNumber') }}
        v-text-field(v-model="vendor.accountNumber", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__BankName') }}
        v-text-field(v-model="vendor.bankName", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__BankAddress') }}
        v-text-field(v-model="vendor.bankAddress", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__SwiftCode') }}
        v-text-field(v-model="vendor.bankSwiftCode", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__Website') }}
        v-text-field(v-model="vendor.website", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__Tel') }}
        v-text-field(v-model="vendor.phone", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__Mobile') }}
        v-text-field(v-model="vendor.mobile", solo, dense, outlined)
        .field-label 
          span {{ $t('ContactInfo.__Fax') }}
        v-text-field(v-model="vendor.fax", solo, dense, outlined)
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
import * as unsaveNotify from "@/utils/unsaveNotify.js"

export default {
  mixins: [unsaveNotify.mixin],
  components: {},
  data() {
    return {
      sumupid: "",
      formValid: false,
      rules: textfieldUtils.rules,
      editType: 1,
      isSameAsBilling: false,
      cid: 0,
      vendor: {}
    }
  },
  methods: {
    getVendor(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("vendors/getVendor", id)
        .then(
          function(response) {
            this.vendor = response.data
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getBiz(id) {
      if (id == null || id == "") {
        this.$store.dispatch("global/showAlertError", "please enter Id for searching")
      } else {
        this.$store.dispatch("global/closeAlert")
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("bizes/getBiz", id)
          .then(
            function(response) {
              this.vendor = response.data
              this.vendor.relatedBusinessId = this.vendor.id
              this.$store.dispatch("global/stopLoading")
              this.$refs.vendorform.resetValidation()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/stopLoading")
              this.$store.dispatch("global/showAlertError", error.message)
            }.bind(this)
          )
      }
    },
    searchDisplayId(id) {
      this.getBiz(id)
    },
    saveEdit() {
      this.$refs.vendorform.validate()
      if (this.formValid) {
        if (this.editType == 1) {
          this.createVendor()
        } else {
          this.updateVendor()
        }
      }
    },
    createVendor() {
      this.$store.dispatch("global/startLoading")
      this.updateShippingInfo()
      this.$store
        .dispatch("vendors/createVendor", this.vendor)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Vendors",
              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyCreated"),
                  type: "success"
                }
              }
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateVendor() {
      this.$store.dispatch("global/startLoading")
      this.updateShippingInfo()
      this.$store
        .dispatch("vendors/updateVendor", this.vendor)
        .then(
          function(response) {
            this.savedTag = true
            this.$router.push({
              name: "Vendors",

              params: {
                alert: {
                  message: this.$t("Messages.__SuccessfullyUpdated"),
                  type: "success"
                }
              }
            })
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateShippingInfo() {
      if (this.isSameAsBilling) {
        ;(this.vendor.shippingPostalCode = this.vendor.billingPostalCode),
          (this.vendor.shippingAddress = this.vendor.billingAddress),
          (this.vendor.shippingRecipient = this.vendor.name),
          (this.vendor.shippingCountryCode = this.vendor.billingCountryCode)
      }
    }
  },
  created() {
    if (this.$route.name == "VendorNew") {
      this.editType = 1
    } else {
      this.cid = this.$route.params.cid
      this.editType = 2
      this.getVendor(this.cid)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/formcontrol.scss";
</style>
